export const leadDataStyles = {
  select: {
    minWidth: 150,
    "& .MuiSelect-select": {
      fontSize: 13,
      color: "#333333",
    },
  },
  textField: {
    minWidth: 150,
    "& .MuiInputBase-input": {
      fontSize: 13,
      color: "#333333",
    },
  },
  removeButton: {
    minWidth: 40,
    fontSize: 12,
  },
  width50: {
    width: 1 / 2,
    mb: 1,
  },
  summaryCard: {
    py: 3,
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 2,

    "@media (max-width: 1250px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    "@media (max-width: 1100px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media (max-width: 800px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  },
  loadingContainer: {
    position: "absolute",
    top: 0,
    width: "90%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  tableContainer: {
    border: "1px solid #E0E0E0",
    borderRadius: 2,
    padding: 2,
  },
  paginationCount: {
    color: "#555555",
    display: "flex",
    gap: 1.5,
    alignItems: "center",
  },
  paginationCountContainer: {
    fontSize: 12,
    fontWeight: 500,
    border: 1,
    borderColor: "#CCD2DE",
    px: 1.5,
    py: 0.25,
    borderRadius: 2,
  },
  excelUploadContainer: {
    border: "1px dashed #FF6A00",
    borderRadius: "16px",
    p: 4,
    minHeight: "150px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    backgroundColor: "rgba(255, 106, 0, 0.03)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "rgba(255, 106, 0, 0.08)",
    },
  },
  uploadIcon: {
    fontSize: 50,
    color: "#FF6A00",
    mb: 1,
  },
  fileNameContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    backgroundColor: "rgba(255,106,0,0.08)",
    border: "1px solid #FF6A00",
    borderRadius: "8px",
    px: 2,
    py: 1,
  },
  fileNameText: {
    color: "#FF6A00",
    maxWidth: "200px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  closeIcon: {
    fontSize: 20,
    color: "#FF6A00",
    cursor: "pointer",
    "&:hover": { color: "red" },
  },
};
